"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AutoLogout = function AutoLogout(_ref) {
  var fields = _ref.fields;
  var autoLogout = fields.autoLogout,
    autoLogoutTime = fields.autoLogoutTime,
    anonAutoLogoutMessage = fields.anonAutoLogoutMessage,
    individualPasscode = fields.individualPasscode,
    knownAutoLogoutMessage = fields.knownAutoLogoutMessage,
    respondentConfig = fields.respondentConfig;
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: autoLogout,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Will respondents be logged out after inactivity?"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input mt-2",
    type: "radio",
    checked: autoLogout.value,
    onChange: function onChange() {
      autoLogout.onChange(true);
    },
    value: autoLogout.value
  }), ' ', /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Close respondent survey session after"), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: autoLogoutTime,
    wrapperClassName: ""
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(autoLogoutTime), {
    min: "1",
    className: "form-control form-control-sm",
    type: "number",
    style: {
      maxWidth: '75px',
      marginRight: '0.5em'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", null, "minutes of inactivity")))), respondentConfig.value === 'anonymous' && autoLogout.value || respondentConfig.value === 'manual' && autoLogout.value && !individualPasscode.value ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "ms-4"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    key: respondentConfig.value,
    field: respondentConfig.value === 'anonymous' ? anonAutoLogoutMessage : knownAutoLogoutMessage,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Logout message",
      tooltip: "Message to show respondents when they are automatically logged out."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: respondentConfig.value === 'anonymous' ? anonAutoLogoutMessage : knownAutoLogoutMessage,
    inputStyle: {
      minHeight: '100px'
    }
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    checked: !autoLogout.value,
    onChange: function onChange() {
      autoLogout.onChange(false);
    },
    value: !autoLogout.value
  }), ' ', "No inactivity timeout")));
};
var _default = exports["default"] = AutoLogout;
AutoLogout.propTypes = {
  fields: _propTypes["default"].object
};